export const API_BASE_URL = (import.meta.env.VITE_API_URL || 'http://localhost:8000') + '/api/v1'
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''
export const WS_URL = import.meta.env.VITE_WS_URL || 'ws://localhost:8000'

export const DEVICE_TYPES = {
  WATERSENSE: 'watersense',
  RK900: 'rk900',
  DHT11SOIL: 'dht11soil'
} as const

export const DEVICE_STATUS = {
  INACTIVE: 'INACTIVE',
  ACTIVATED: 'ACTIVATED',
  DECOMMISSIONED: 'DECOMMISSIONED'
} as const

export const ALERT_SEVERITY = {
  INFO: 'info',
  WARNING: 'warning',
  CRITICAL: 'critical'
} as const

export const CONTACT_PREF = {
  EMAIL: 'email',
  SMS: 'sms',
  BOTH: 'both'
} as const

export const ACCOUNT_TYPES = {
  CUSTOMER: 'customer',
  DEALER: 'dealer',
  DISTRIBUTOR: 'distributor'
} as const
